<template>
  <div
    class=" cactus-groups__item accordion box"
    v-show="isVisible"
    role="presentation"
    :class="classes"
  >
    <div :id="groupId" class="accordion-item--content__wrapper" :class="cactusGroup.label">
      <!-- Accordion item: Header -->
      <slot name="header">
        <div class="accordion-item__header" v-if="title">
          <button @click="toggle" class="accordion-item__trigger" :disabled="read">
            <h2 class="accordion-item__title">{{ title }}</h2>
            <span class="accordion-item__trigger--icon" v-if="!read"></span>
          </button>
        </div>
      </slot>

      <transition
        name="accordion-item"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <div v-if="open" class="accordion-item-details">
          <div class="accordion-item-details-inner">
            <slot name="prepend"></slot>

            <slot :group="item">
              <div class="cactusGroup">
                <div :class="[{ withBorder: item.border }]">
                  <div
                    class="cactusGroup-element"
                    :class="[
                      { withBorder: item.border },
                      'indentation-' + element.indentation_level
                    ]"
                    v-for="(element, index) in item.elements"
                    :key="index"
                  >
                    <div
                      v-for="(stackEl, index) in element.stack_elements"
                      :key="index"
                      class="cactusGroup-element__child"
                      :class="['slotsQty-' + element.slots]"
                    >
                      <cw-generic
                        v-if="stackEl.type === 'parameter'"
                        :component-data="getParam(stackEl.type, stackEl.name)"
                        :ref="stackEl.name.toLowerCase()"
                      ></cw-generic>

                      <cw-generic-decoration
                        v-if="stackEl.type === 'decoration'"
                        :component-data="getParam(stackEl.type, stackEl.name)"
                      ></cw-generic-decoration>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import _find from 'lodash/find';
import { mapActions, mapGetters } from 'vuex';

import AccordionItem from './../_ui/accordion/AccordionItem';

import CwGeneric from './cwGeneric.vue';
import CwGenericDecoration from './cwGenericDecoration.vue';
import expertviewMixin from './experviewMixin';
import CactusStrings from './CactusStringsMixin';

export default {
  name: 'CactusGroup',
  extends: AccordionItem,
  components: { CwGeneric, CwGenericDecoration },
  mixins: [expertviewMixin, CactusStrings],
  props: ['cactusGroup', 'active', 'readOnly'],
  data() {
    return {
      open: true,
      read: true,
      rulesVisibility: [],
      groupRules: [],
      cactusElements: require('./cactus_elements.json')
    };
  },
  created() {
    this.$log.debug('cwCactusGroup::created()');
    this.confGroupsUI();
  },
  methods: {
    ...mapActions(['getLatestAppData']),

    getQueryObject(sn) {
      return {
        deviceSerialNumber: sn,
        requestGranularity: '1h',
        requestStartTime: this.$moment(new Date())
          .startOf('day')
          .format('YYYY-MM-DD[T]HH:mm:ssZ'),
        requestEndTime: this.$moment(new Date())
          .endOf('day')
          .format('YYYY-MM-DD[T]HH:mm:ssZ'),
        version: '1.0'
      };
    },

    getParam(elType, elName) {
      let typeName = elType;
      if (elType === 'parameter') typeName = 'parameters';
      if (elType === 'decoration') typeName = 'decorations';

      // this.$log.debug('ExpertviewWriteable::getParam()', typeName, elName);

      try {
        return _find(this.cactusElements[typeName], { name: elName }, {});
      } catch (err) {
        this.$log.warn('ExpertviewWriteable::getParam -> el not found');
        return {};
      }
    },
    isGroupVisible(obj) {
      if (obj) {
        this.groupRules.push(...obj);

        const filteredGroups = this.groupRules.map(e => {
          if (e.target === 'visibility') {
            return e;
          }
          return {};
        });

        this.groupRules = filteredGroups;
        this.rulesVisibility = this.groupRules[0] ? this.groupRules[0].rule : null;
        this.applyRules();
      }
    },
    toggle() {
      /* if (this.multiple) this.active = !this.active;
      else {
        this.$parent.$children.forEach(item => {
          if (item.$el.id === event.currentTarget.parentElement.parentElement.id) {
            item.active = !item.active;
          } else item.item.active = false;
        });
      } */
      this.open = !this.open;
    },
    confGroupsUI() {
      this.groupId = this.item.label;
      if (this.item.expandable) {
        this.read = false;
        this.open = true;
      } else {
        this.open = true;
        this.read = true;
      }
    }
  },
  computed: {
    ...mapGetters(['latestAppData']),
    ruleSubscriber() {
      return [];
    },
    classes() {
      return {
        'is-active': this.open
      };
    },
    isVisible() {
      if (this.rulesVisibility) {
        return this.visibilityWithRules;
      } else {
        // for components with no rules
        return true;
      }
    },
    isActive: function() {
      return true;
    },
    isReadOnly: {
      get() {
        return this.read;
      },
      set() {
        this.read = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$size: 20px;
.cactus-groups__item--title {
  padding-top: 50px;
}
.cactusGroup {
  display: block;
  clear: both;
  // margin-top: 50px;

  h2 {
    font-size: 16px;
    color: $greeny-blue;
    margin: 30px 0 10px 5px;
  }

  & > .withBorder {
    border: 1px solid $cloudy-blue;
    border-radius: 8px;
    margin-top: 10px;

    .withBorder {
      margin: 0;

      &:first-child {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid $cloudy-blue;
      }

      &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      /deep/ .dropdown-l {
        border: 0 !important;
      }

      + .withBorder {
        border: 0;
      }
    }
  }

  &-element {
    width: 100%;
    clear: left;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 10px;

    &.withBorder {
      // two elements

      // three elements

      // three and more elements

      @include siblings-by-count(n + 2, &) {
        border: 2px solid red;
      }
    }

    &.indentation {
      &-1 {
        margin: 0 auto;
      }
    }

    &__child {
      flex: 1;

      &.slotsQty {
        &-1 {
          flex: 1 1 100%;
        }

        &-2 {
          flex: 0 1 50%;
        }

        &-3 {
          flex: 0 1 33%;
        }

        &-4 {
          flex: 0 1 25%;
        }
      }
    }
  }
}

.accordion-item {
  transition: all 0.4s linear;
}

.accordion-item__header {
  // position: relative;
  display: flex;
  align-content: center;
}

.accordion-item__trigger,
.accordion-item-details-inner {
  //padding: 0.75rem 1.25rem;
  padding: 0;
  margin: 12px 0 0 0;
}

.accordion-item__trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:disabled {
    cursor: pointer;
    pointer-events: none;
  }
}

.accordion-item__trigger--icon {
  // margin: 12px 0 0;

  &:after {
    background: url(../../assets/img/ico-expand-list.svg) center center no-repeat;
    content: '';
    height: $size;
    width: $size;
    float: right;
    transition: all 0.4s ease;
  }
  // transform: translateY(-$size / 4) rotate(45deg);

  .is-active & {
    // transform: translateY($size / 4) rotate(225deg);

    &:after {
      transform: translateY(0) rotate(180deg);
    }
  }
}

.accordion-item-details {
  background-color: #ffffff;
  transition: all 0.4s ease-out;
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.1s ease-out;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
